export const parseAcceptLanguage = (header?: string | null): string => {
	if (!header) return 'en';
	return (
		header
			.split(',')
			.map(part => {
				const [lang, qPart] = part.trim().split(';');
				const q = qPart ? parseFloat(qPart.split('=')[1]) : 1;
				return { lang, q };
			})
			.sort((a, b) => b.q - a.q)[0]?.lang || 'en'
	);
};

export const getBrowserLanguageFromHeaders = (
	headers: { [key: string]: string | string[] | undefined } | Headers | undefined,
): string => {
	let header: string | undefined;
	if (!headers) return 'en';
	if (headers instanceof Headers) {
		header = headers.get('accept-language') || undefined;
	} else {
		const h = headers['accept-language'];
		header = Array.isArray(h) ? h[0] : h;
	}
	return parseAcceptLanguage(header);
};
